import { Component, Input, OnInit } from '@angular/core';
import { EgiPageMetaData } from '@ervo/page-framework';
import { BooleanInput } from '@shared/decorators/boolean-input.decorator';

@Component({
    selector: 'egi-page-info[metaData]',
    templateUrl: './egi-page-info.component.html',
    styleUrls: ['./egi-page-info.component.css'],
    standalone: false
})
export class EgiPageInfoComponent implements OnInit {
  @Input() metaData: EgiPageMetaData;

  @BooleanInput() @Input() hideName: boolean;
  @BooleanInput() @Input() hideDependencies: boolean;
  @BooleanInput() @Input() showPreview: boolean;
  @BooleanInput() @Input() showId: boolean;
  @BooleanInput() @Input() hidePath: boolean;
  @BooleanInput() @Input() showTopic: boolean;

  constructor() {}

  ngOnInit(): void {}

  get baseUrl(): string {
    return window.location.origin;
  }
}
